module.exports = __webpack_public_path__ + "assets/static/media/bg_error_500.02dfa7ef.png";